import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { themeColors } from '../../styles/themeColors';
import { stylesConstants } from '../../styles/stylesConstants';

const minWidth = (theme: Theme) => stylesConstants.inputFormWidth + theme.spacing(8);

const borderTop = (theme: Theme) => ({
  borderTopLeftRadius: theme.spacing(1),
  borderTopRightRadius: theme.spacing(1),
});

const tab = (theme: Theme) => ({
  ...borderTop(theme),
  width: stylesConstants.tabWidth,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export default makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(2),
    backgroundColor: themeColors.secondary,
    borderRadius: theme.spacing(1),
    boxShadow: theme.shadows[1],
    overflow: 'hidden',
  },
  tabBar: {
    ...borderTop(theme),
    backgroundColor: themeColors.tabBarBg,
    height: stylesConstants.tabInactiveHeight,
    overflow: 'visible',
    display: 'flex',
    alignItems: 'flex-end',
    minWidth: minWidth(theme),
  },
  tabActive: {
    ...tab(theme),
    height: stylesConstants.tabActiveHeight,
    backgroundColor: themeColors.secondary,
  },
  tabInactive: {
    ...tab(theme),
    height: stylesConstants.tabInactiveHeight,
    backgroundColor: themeColors.tabBarBg,
    color: themeColors.textSecondary,
  },
  tabActiveTypography: {
    fontWeight: 600,
    color: themeColors.textPrimary,
  },
  tabInactiveTypography: {
    fontWeight: 600,
    color: themeColors.textSecondary,
  },
  bottomContainer: {
    backgroundColor: themeColors.secondary,
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(3),
  },
  headerContainer: {
    display: 'flex',
    margin: theme.spacing(2),
    marginBottom: 0,
    alignItems: 'center',
  },
  headerTitle: {
    fontWeight: 600,
  },
  switchContainer: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  description: {
    backgroundColor: themeColors.secondary,
    padding: theme.spacing(2),
    display: 'flex',

    flexWrap: 'wrap',
  },
  mainContainer: {
    width: 'fit-content',
  },
  hint: {
    marginLeft: 'auto',
    padding: theme.spacing(2),
    fontSize: 12,
    color: '#aaa',
  },
}));
